import { combineReducers } from '@reduxjs/toolkit';

// slices
import config from 'features/config/configSlice';
import matchState from 'features/match/matchSlice';
import modals from 'features/modals/modalsSlice';
import input from 'features/input/inputSlice';
import stats from 'features/stats/statsSlice';
import network from 'features/network/networkSlice';
import timeState from 'features/time/timeSlice';
import keyboardState from 'features/keyboard/keyboardSlice';
import user from 'features/user/userSlice';

const rootReducer = combineReducers({
  config,
  matchState,
  modals,
  input,
  stats,
  network,
  timeState,
  keyboardState,
  user,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
